import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography, Box, helperMargin, IconSvg, Button } from '@utex/ui-kit';
import {
  FooterWrapper,
  Title,
  Wrapper,
  Col,
  Line,
  socialIcon,
  AppButton,
  ButtonText
} from './styles';

export interface Props {
  isWhite?: boolean;
}

export function Footer(props: Props) {
  const { t } = useTranslation(['footer', 'links']);

  return (
    <FooterWrapper {...props}>
      <Wrapper>
        <Box marginRight={{ desktop: 50, tablet: 30 }}>
          <Col>
            <Title>{t('footer:Mobile Apps')}</Title>
            <AppButton>
              <Button
                href={t('links:app-store-link')}
                target="_blank"
                rel="noopener noreferrer"
                view="muted"
                size={{ tablesktop: 'M', phonablet: 'L' }}
              >
                <IconSvg src="apple" />
                <ButtonText>
                  {t('footer:Available on the')}
                  <br />
                  <b>App&nbsp;Store</b>
                </ButtonText>
              </Button>
              <Button
                href={t('links:google-play-link')}
                target="_blank"
                rel="noopener noreferrer"
                view="muted"
                size={{ tablesktop: 'M', phonablet: 'L' }}
              >
                <IconSvg src="google-play" />
                <ButtonText>
                  {t('footer:Get it on')}
                  <br />
                  <b>Google&nbsp;Play</b>
                </ButtonText>
              </Button>
            </AppButton>
          </Col>
        </Box>
      </Wrapper>
      <Wrapper>
        <Col>
          <Title>{t('footer:Social')}</Title>
          <Line href={t('links:yt-link')} target="_blank">
            <IconSvg src="youtube" css={socialIcon} />
            <Typography.Text css={helperMargin({ left: 30 })}>YouTube</Typography.Text>
          </Line>
          <Line href={t('links:tg-link')} target="_blank">
            <IconSvg src="telegram" css={socialIcon} />
            <Typography.Text css={helperMargin({ left: 30 })}>Telegram</Typography.Text>
          </Line>
          <Line href={t('links:tw-link')} target="_blank">
            <IconSvg src="twitter" css={socialIcon} />
            <Typography.Text css={helperMargin({ left: 30 })}>Twitter</Typography.Text>
          </Line>
        </Col>
        <Col>
          <Title>{t('footer:Sections')}</Title>
          <Line href={t('links:partnership-link')} target="_blank">
            <Typography.Text>{t('footer:Partnership')}</Typography.Text>
          </Line>
          <Line href={t('links:traiding-link')} target="_blank">
            <Typography.Text>{t('footer:Traiding')}</Typography.Text>
          </Line>
          <Line href={t('links:contacts-link')} target="_blank">
            <Typography.Text>{t('footer:Contacts')}</Typography.Text>
          </Line>
        </Col>
      </Wrapper>
      <Wrapper>
        <Col>
          <Title>{t('footer:Help')}</Title>
          <Line href={t('links:tg-bot-link')} target="_blank">
            <Typography.Text>{t('footer:Telegram')}</Typography.Text>
          </Line>
          <Line href={t('links:whatsapp-link')} target="_blank">
            <Typography.Text>{t('footer:Whatsapp')}</Typography.Text>
          </Line>
          <Line href={t('links:email-link')} target="_blank">
            <Typography.Text>{t('footer:Email')}</Typography.Text>
          </Line>
        </Col>
        <Box marginLeft={{ tablesktop: 'auto' }}>
          <Col>
            <Title>{t('footer:Documents')}</Title>
            <Line href={t('links:agreement-link')} target="_blank">
              <Typography.Text>{t('footer:License agreement')}</Typography.Text>
            </Line>
            <Line href={t('links:risk-link')} target="_blank">
              <Typography.Text>{t('footer:Risk Statement')}</Typography.Text>
            </Line>
            <Line href={t('links:privacy-link')} target="_blank">
              <Typography.Text>{t('footer:Privacy policy')}</Typography.Text>
            </Line>
          </Col>
        </Box>
      </Wrapper>
    </FooterWrapper>
  );
}
